<template>
  <div class="columns">
    <div class="column is-7">
      <div class="document description">
        <table>
          <tr>
            <td><strong>{{ $t('projects.sourceType') }}</strong></td>
            <td>{{$t(`projectControl.sourceTypes.${detail.source_type}`)}}</td>
            <td><strong>{{ $t('projects.department') }}</strong></td>
            <td>{{detail.department__name ? detail.department__name : '&ndash;'}}</td>
          </tr>
          <tr>
            <td><strong>{{ $t('projects.customer') }}</strong></td>
            <td>{{detail.customer__name ? detail.customer__name : '&ndash;'}}</td>
            <td><strong>{{ $t('projects.beneficiary') }}</strong></td>
            <td>{{detail.beneficiary__name ? detail.beneficiary__name : '&ndash;'}}</td>
          </tr>
          <tr>
            <td><strong>{{ $t('projects.projectType') }}</strong></td>
            <td>{{detail.category__name}}</td>
            <td><strong>{{ $t('projects.branch') }}</strong></td>
            <td>{{detail.branch__name}}</td>
          </tr>
          <tr>
            <td><strong>{{ $t('projects.state') }}</strong></td>
            <td>
              <b-tag :type="`is-${stateColors[detail.state]}`">
                {{ $t(`projectControl.states.${detail.state}`) }}
              </b-tag>
            </td>
            <td><strong></strong></td>
            <td></td>
          </tr>
          <tr>
            <td><strong>{{ $t('projects.budget') }}</strong></td>
            <td>{{detail.plan_budget | million | numberWithCommas}} млн. сум</td>
            <td><strong>{{ $t('projects.spend') }}</strong></td>
            <td>&ndash;</td>
          </tr>
          <tr>
            <td><strong>{{ $t('projects.planStartDate') }}</strong></td>
            <td>{{ detail.plan_start_date | localedDate }}</td>
            <td><strong>{{ $t('projects.planEndDate') }}</strong></td>
            <td>{{ detail.plan_end_date | localedDate }}</td>
          </tr>
          <tr>
            <td><strong>{{ $t('projects.factStartDate') }}</strong></td>
            <td v-if="detail.fact_start_date ">{{detail.fact_start_date | localedDate}}</td>
            <td v-else>&ndash;</td>
            <td><strong>{{ $t('projects.factEndDate') }}</strong></td>
            <td v-if="detail.fact_end_date ">{{detail.fact_end_date | localedDate}}</td>
            <td v-else>&ndash;</td>
          </tr>
        </table>
        <div>
          <strong>{{ $t('interface.description') }}</strong>
          <p>{{detail.description}}</p>
        </div>
      </div>
      <div>
        <Attachments class="mt-15"
                     size="large"
                     @file-upload="uploadLegal"
                     @remove-file="removeLegal"
                     :editable="true"
                     :upload="upload"
                     :title="$t('projects.legals')"
                     :types="docTypes"
                     :data="legals">
        </Attachments>
      </div>
    </div>
    <div class="column is-5">
      <Attachments class="mt-15"
                   @file-upload="uploadFile"
                   @remove-file="removeFile"
                   :editable="true"
                   :upload="upload"
                   :title="$t('projects.files')"
                   :types="attachmentTypes"
                   :data="detail.attachments">
      </Attachments>
    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {stateColors} from '../colorTypes'
  import Attachments from '@/components/Attachments'

  export default {
    components: {
      Attachments
    },
    data() {
      return {
        stateColors
      }
    },
    methods: {
      uploadFile({file, type}) {
        this.$store.dispatch('Project/uploadFile', {file, type})
      },
      removeFile(fileId) {
        this.$store.dispatch('Project/removeFile', fileId).then(() => this.$toast.open('Файл успешно удален'))
      },
      uploadLegal({file, type}) {
        this.$store.dispatch('Project/uploadLegal', {file, type})
      },
      removeLegal(fileId) {
        this.$store.dispatch('Project/removeLegal', fileId).then(() => this.$toast.open('Файл успешно удален'))
      },
    },
    computed: {
      ...mapState('Project', ['detail', 'attachmentTypes', 'docTypes', 'loading', 'upload']),
      ...mapGetters('Project', ['legals'])
    }
  }
</script>

<style lang="scss">
  @import "../assets/variables";

  .document.description {
    color: #666;
    table {
      width: 100%;

      td {
        padding-bottom: 10px;
      }

      tr > td:first-child,
      tr > td:nth-child(3) {
        width: 140px;
      }
    }

    & > div {
      margin-top: 10px;
      & > p {
        margin-top: 4px;
      }
    }
  }

  .title.is-6 {
    margin-bottom: 15px;
  }

  .file-tile {
    .doctype {
      width: 68px;
      position: relative;
      left: -10px;
      top: 4px;
    }

    .media-left {
      margin-right: 0;
    }

    .name {

    }

    .date {
      font-size: 13px;
      color: #888;
      margin-bottom: 4px;
    }

    a {
      .icon {
        position: relative;
        top: 1px;
      }
    }
  }
</style>